import { VoucherDto } from "@/types/types";

import { mhhlApi as api } from "./mhhlApi";

type GetVoucherApiResponse = {
  vouchers: VoucherDto[];
};

type ConnectVoucherApiResponse = VoucherDto;

type ConnectVoucherApiArg = {
  id: string;
  code: string;
};

const vouchersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getActiveVouchers: build.query<GetVoucherApiResponse, void>({
      query: () => `/api/v1/patients/vouchers/active`,
    }),
    getInactiveVouchers: build.query<GetVoucherApiResponse, void>({
      query: () => `/api/v1/patients/vouchers/inactive`,
    }),
    connectVoucher: build.mutation<ConnectVoucherApiResponse, ConnectVoucherApiArg>({
      query: ({ id, code }) => ({
        url: `/api/v1/patients/${id}/connect_voucher/${code}`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});

export { vouchersApi };
export const { useGetActiveVouchersQuery, useGetInactiveVouchersQuery, useConnectVoucherMutation } = vouchersApi;
